export * from './types'
export { DatesService } from './dates.service'

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { BurtUiModule } from '@burt-ui';
import { CalendarComponent } from './calendar/calendar.component'
import { CalendarMonthComponent } from './calendar/month/calendar-month.component'
import { DateRangePickerComponent } from './date-range-picker.component'

import { DatesService } from './dates.service'

@NgModule({
  declarations: [
    CalendarComponent,
    CalendarMonthComponent,
    DateRangePickerComponent,
  ],
  exports: [
    DateRangePickerComponent,
    CommonModule,
    FormsModule,
  ],
  imports: [
    CommonModule,
    FormsModule,
    BurtUiModule,
  ],
  providers: [
    DatesService
  ]
})
export class DateRangePickerModule { }
